﻿const isInitialized = DS.Config.SENTRY_ENABLED && window.Sentry && !window.sitecoreEnv;

/**
 * message <String> The message that will be the title in Sentry
 * data <Object>: The object that holds the data that should be logged in Sentry
 */
export const capture = function (message: string, data: Record<string, any>) {
  if (!isInitialized) {
    console.warn('Sentry is not enabled', { message: message, data: data });
    return;
  }

  try {
    window.Sentry.captureMessage(message, data);
  } catch (error) {
    console.warn('Sentry logging failed', { message: message, data: data }, error);
  }
};